import React, { useState, useEffect } from "react";
import { Context } from "../context";
import PreParser from "../preParser";
import NavMenu from "./header/menu/nav-menu";
const Footer = () => {
    // const props = useStaticQuery(query);
    const context = React.useContext(Context);
    const footer = context.footerTemplate.jsonContent;
    const [elevatorState, setElevatorState] = useState(false);
    if (typeof window !== "undefined") {
        useEffect(() => {
            const scrollWatcher = () => {
                if (window.scrollY > window.innerHeight && !elevatorState) {
                    setElevatorState(true);
                }
                if (window.scrollY < window.innerHeight && elevatorState) {
                    setElevatorState(false);
                }
            };
            window.addEventListener("scroll", scrollWatcher);
            return () => {
                window.removeEventListener("scrollr", scrollWatcher);
            };
        }, [elevatorState, setElevatorState, window]);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { href: "#", title: "Revenir en haut", id: "backtotop", className: elevatorState ? "expanded" : "collapsed" },
            React.createElement("span", { className: "sr-only" }, "Utilisez ce bouton pour revenir en haut de la page.")),
        React.createElement(PreParser, { structure: footer },
            React.createElement(NavMenu, { className: "footerMenu", nav: context.menus.footer, id: "footerMenu", label: "Menu de navigation de pied de page", visible: true }))));
};
export default Footer;
